export default 'teamsPage';
